import { controlTower } from "@/utils/constants";
import { handleError, handleResponse } from "@/utils/functions";

export default (axios) => ({
    getControlTowerDashboardData(params = {}) {
        return new Promise((resolve, reject) => {
            axios
                .get(controlTower.controlTowerBase, { params })   
                .then((res) => {
                    resolve(handleResponse(res));
                })
                .catch((err) => {
                    reject(handleError(err));
                });
        });
    }


});
